import type { ReactNode } from 'react';
import { useState } from 'react';
import { FinixEnvironmentContext } from './FinixEnvironmentContext';
import type { FinixEnvironment } from '@/lib/finixProxy';

interface FinixEnvironmentProviderProps {
  children: ReactNode;
}

export const FinixEnvironmentProvider: React.FC<
  FinixEnvironmentProviderProps
> = ({ children }) => {
  const [environment, setEnvironment] = useState<FinixEnvironment>(
    (import.meta.env.VITE_FINIX_DEFAULT_ENVIRONMENT as FinixEnvironment) ??
      'sandbox',
  );

  return (
    <FinixEnvironmentContext.Provider value={{ environment, setEnvironment }}>
      {children}
    </FinixEnvironmentContext.Provider>
  );
};
